module.exports = __webpack_public_path__ + "static/img/fea08.2fa26dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/fea08.png
// module id = Qwc/
// module chunks = 1